let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("znNxD")).then(() => parcelRequire('74zHr'));